<template>
    <div v-if="this.device">
        <VueSidePanel
            v-model="showDelete"
            height="130px"
            hide-close-btn
            side="bottom"
            :panel-duration="400"
            no-close
            class="deleteModalM"
            :overlay-opacity="0.9"
        >
            <br><br>
            <center>
                <div v-if="!hasActiveSubscription">{{ deleteMessge }}</div><br>
                <p v-if="hasActiveSubscription" class="activeSubsNote mt-2"><b class="noteLabel">Note :</b> This bundle has active subscriptions and cannot be deleted.</p>
                <div class="pt-4">
                    <button class="deleteCancelM" @click.prevent="sendResponse()">Not Now</button>
                    <button v-if="!hasActiveSubscription" class="deleteConfirmM" @click.prevent="confirmDelete()">Yes, Delete</button>
                </div>
            </center>
        </VueSidePanel>
    </div>
    <div v-else>
        <va-modal
            class="popup"
            v-model="showDelete"
            title="Delete Confirmation"
            blur
            hide-default-actions
            no-outside-dismiss
        >
            <p v-if="!hasActiveSubscription">{{ deleteMessge }}</p>
            <p v-if="hasActiveSubscription" class="activeSubsNote mt-2"><b class="noteLabel">Note :</b> This bundle has active subscriptions and cannot be deleted.</p>
            <div style="display: flex; justify-content: center; margin-top: 1rem;">
                <va-button preset="secondary" style="margin-right: 0.5rem;" @click="sendResponse()">Not Now</va-button>
                <va-button v-if="!hasActiveSubscription" color="#f1711a" @click="confirmDelete()">Yes, Delete</va-button>
            </div>
        </va-modal>
    </div>
</template>

<script>
    export default{
        props:{
            deleteMessge: String,
            deleteApi: String,
            deleteId: String,
            hasActiveSubscription: { type: Boolean, default: false }
        },
        data(){
            return{
                showDelete: true,
                device: this.$globalDevice == 'mobile' ? true : false
            }
        },
        methods: {
            confirmDelete(){
                const response = this.$del(this.deleteApi+'/'+this.deleteId, this.$loading, this.$toast)
                if(response) {
                    this.$emit('response-event', {'code':200,'data':null});
                }else this.$emit('response-event', {'code':500,'data':null});
            },
            sendResponse(){
                this.showDelete = false;
                this.$emit('response-event', {'code':404,'data':null});
            }
        }
    }
</script>

<style scoped>
.activeSubsNote {
    padding: 12px;
    background-color: #fff3cd;
    border-left: 4px solid #ff9800;
    border-radius: 4px;
    color: #856404;
    text-align: left;
}
.noteLabel {
    color: #ff6b00;
}
</style>